module.exports = __webpack_public_path__ + "img/app_mockup.0b35b4c7.png";